module.exports = __webpack_public_path__ + "static/media/dark-motion-spacecraft-design-analysis.42b19b4.mp4";